// 赋值链接到剪贴板方法
export const copyMethod = (link: string, cb?: () => void) => {
    const oInput = document.createElement('input');
    oInput.value = link;
    document.body.appendChild(oInput);
    oInput.select(); // 选择对象
    document.execCommand('Copy'); // 执行浏览器复制命令
    oInput.className = 'oInput';
    oInput.style.display = 'none';
    document.body.removeChild(oInput);
    cb && cb();
};

// 生成随机数
export const uuid = (len?: any, radix?: any, chars?: any) => {
    const newChars = (chars || '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz').split('');
    const $uuid = [];
    let i;
    const newRadix = radix || newChars.length;

    if (len) {
        for (i = 0; i < len; i++) {
            $uuid[i] = newChars[0 | (Math.random() * newRadix)];
        }
    } else {
        let r;
        $uuid[8] = $uuid[13] = $uuid[18] = $uuid[23] = '-';
        $uuid[14] = '4';
        for (i = 0; i < 36; i++) {
            if (!$uuid[i]) {
                r = 0 | (Math.random() * 16);
                $uuid[i] = newChars[i === 19 ? (r & 0x3) | 0x8 : r];
            }
        }
    }

    return $uuid.join('');
};

export const getBaseUrl = () => {
    if (window.location.host.includes('v.gaodun.com')) {
        return '/space';
    }
    return '/';
};
